<mat-card appearance="outlined">
    <mat-card-content>
        <app-assets-list context="Versions" contextId="{{versionId}}"></app-assets-list>
        <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 16px;">
            <button mat-stroked-button type="reset" color="accent" (click)="onClose()">Close</button>
        </div>
    </mat-card-content>
</mat-card>